module.exports = __webpack_public_path__ + "static/52facesheader-e8222e656a8da2cc5ab40c565831dba1.png";